import { showSuccessToast } from "@fuse/sharedComponents/themeToast/toastUtils"

import { logAnalyticEvent } from "@firebaseConfig/analyticsUtil"

import { sendExperimentEngagementToSlack } from "@api/firebaseWrappedApis"

export const RequestAccessButton = ({ experimentName }) => {
  const handleRequestAccess = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    logAnalyticEvent(experimentName, {
      component: "RequestAccesPluginButton",
      action: "click",
    })
    showSuccessToast("You're on the list!", {
      text2: "We'll reach out soon — stay tuned!",
    })
    await sendExperimentEngagementToSlack({
      experimentName,
    })
  }

  return (
    <button
      onClick={handleRequestAccess}
      className="w-full bg-white/10 hover:bg-white/15 text-white py-2 px-6 rounded-lg transition-colors text-base"
    >
      Request early access
    </button>
  )
}

export const TrackableWrapper = ({ children, event, action, component }) => {
  const trackClick = () => {
    console.log("LOGGING..", event, {
      component,
      action,
    })
    logAnalyticEvent(event, {
      component,
      action,
    })
  }
  return <div onClick={trackClick}>{children}</div>
}
